export interface BroodSystemConfig {
  EGG_DURATION: number;
  LARVA_DURATION: number;
  PUPA_DURATION: number;
  LARVA_FOOD_NEEDED: number;
  EGG_LAY_INTERVAL: number;
  MAX_BROOD: number;
  // New: hunger mechanic constants
  LARVA_HUNGER_RATE: number;
  LARVA_HEALTH_DAMAGE_THRESHOLD: number;
  LARVA_HEALTH_DAMAGE_RATE: number;
}

export const DEFAULT_BROOD_CONFIG: BroodSystemConfig = {
  EGG_DURATION: 10000,
  LARVA_DURATION: 20000,
  PUPA_DURATION: 15000,
  LARVA_FOOD_NEEDED: 25,
  EGG_LAY_INTERVAL: 2500,
  MAX_BROOD: 50,
  // New hunger mechanic defaults
  LARVA_HUNGER_RATE: 1.5,
  LARVA_HEALTH_DAMAGE_THRESHOLD: 80,
  LARVA_HEALTH_DAMAGE_RATE: 0.5,
};
